@if (data.imageLink) {
  <button
    (click)="dialogRef.close()"
    class="btn icon-close">
  </button>
}
<img [src]="data.imageLink" alt="">
